export function getRandomId() {
    return Date.now();
}
export function getItemById(sketch, id, userId, userEndpointId) {
    return sketch.scope.project.getItem({
        data: {
            id,
            userId,
            userEndpointId,
        },
    });
}
//# sourceMappingURL=id.js.map